import React from "react";
import joinus from "../assets/joinus.png";
import { useNavigate } from "react-router-dom";
const JoinUs = () => {
  const navigate = useNavigate();
  return (
    <div className="bg-black text-white lg:pl-8">
      <div className="text-center py-12 md:py-24">
        <p className=" text-[32px] md:text-[48px] lg:text-[70px]  tracking-wider font-langit">
          JOIN US TODAY
        </p>
        <p className="text-gray-300 mt-4 px-6 text-[12px]  lg:text-[16px] font-articulat">
          Discover Kosmos Academy — where fitness meets friendship, discipline
          meets fun,
          <br className="hidden md:block" /> and you become the best version of
          yourself.
        </p>
      </div>

      <div
        className="flex flex-col md:flex-row items-center  "
        style={{
          background: "linear-gradient(to right , #0B2F54 , #0C0C0C)",
          borderTopLeftRadius: "12px",
          borderBottomLeftRadius: "12px",
        }}
      >
        <div className="flex-1 text-center md:text-left pt-6 md:pl-10 lg:pl-20">
          <p className="text-[24px] lg:text-[32px] xl:text-[60px]  tracking-wider mb-4 font-langit">
            READY TO ELEVATE
          </p>
          <p className="text-gray-300 px-6 md:px-0 mb-6 text-[12px] lg:text-[20px] tracking-wide font-articulat">
            Ready to elevate your health, build connections, and have fun?{" "}
            <br className="hidden md:block" />
            Check out our membership options or book a trial class now.
          </p>
          <button
            type="button"
            onClick={() => navigate("/registration/personalinformation")}
            className="bg-white text-black px-6 py-2 border-none uppercase text-[24px] font-league hover:bg-gray-200 transition cursor-pointer"
          >
            Register
          </button>
        </div>

        <div className="flex-1">
          <img src={joinus} alt="Badminton player" className="w-full h-auto" />
        </div>
      </div>
    </div>
  );
};

export default JoinUs;
